import { ReactNode } from 'react';

import { SidebarSection } from './SidebarSection';

type Props = {
  children: ReactNode;
};

export function SidebarOrgSection(props: Props) {
  return <SidebarSection title="Organization">{props.children}</SidebarSection>;
}
